export { AtnRuleSlideoutComponent as Component } from './rule-slideout.component'
